"use client";

import {
  GameImage,
  FollowersChange,
} from "@/components/shared";
import { ColumnDef } from "@/components/shared/data-table";
import type { SkeletonColumn } from "@/components/shared/list-skeleton";
import type { PublisherGameFollowers } from "../types";
import { RANK_LIST_CONFIGS } from "@/features/rank-list/shared";

// Loading skeleton matching publisherGameFollowersColumns (Games Followers tab).
export const publisherGameFollowersSkeletonConfig: SkeletonColumn[] = [
  { label: "Followers", type: "number", width: "w-28" },
  { label: "Image", type: "image", noPadding: true },
  { label: "Name", type: "text", width: "w-48" },
  { label: "Release", type: "date", width: "w-24" },
  { label: "1D", type: "number", width: "w-16" },
  { label: "7D", type: "number", width: "w-16" },
  { label: "30D", type: "number", width: "w-16" },
];

export const publisherGameFollowersColumns: ColumnDef<PublisherGameFollowers>[] = [
  {
    header: "Followers",
    accessorKey: "followers",
    sortable: true,
    sortKey: "followers",
    align: "right",
    width: "w-28",
    cell: (item) => (
      <span
        className="font-bold text-[13px]"
        style={{ color: RANK_LIST_CONFIGS.followers.primaryColor }}
      >
        {item.followers?.toLocaleString("en-US") ?? "—"}
      </span>
    ),
  },
  {
    header: "Image",
    noPadding: true,
    width: "w-[100px]",
    cell: (item) => (
      <div className="w-[100px] h-[37px] flex-shrink-0">
        <GameImage
          src={item.capsule_image}
          alt={item.name}
          width={100}
          height={37}
        fillContainer
        />
      </div>
    ),
  },
  {
    header: "Name",
    accessorKey: "name",
    cell: (item) => (
      <span className="text-white font-medium text-[13px]">{item.name}</span>
    ),
  },
  {
    header: "Release",
    accessorKey: "release_date",
    cell: (item) => (
      <span className="text-[#8f98a0] text-[11px]">
        {item.coming_soon ? "Coming Soon" : item.release_date || "—"}
      </span>
    ),
  },
  {
    header: "1D",
    accessorKey: "followers_1d",
    sortable: true,
    sortKey: "followers_1d",
    align: "right",
    cell: (item) => <FollowersChange value={item.followers_1d} />,
  },
  {
    header: "7D",
    accessorKey: "followers_7d",
    sortable: true,
    sortKey: "followers_7d",
    align: "right",
    cell: (item) => <FollowersChange value={item.followers_7d} />,
  },
  {
    header: "30D",
    accessorKey: "followers_30d",
    sortable: true,
    sortKey: "followers_30d",
    align: "right",
    cell: (item) => <FollowersChange value={item.followers_30d} />,
  },
];
